import './Notice.less'
import Notice from './Notice'
export default Notice
